import { useState, useEffect, useRef } from 'react';
export const useElementOnScreen = (isInitiallyVisible = false, options = {
    root: null,
    rootMargin: '0px',
    threshold: 1.0,
}) => {
    const containerRef = useRef(null);
    const [isVisible, setIsVisible] = useState(isInitiallyVisible);
    useEffect(() => {
        const observer = new IntersectionObserver((entries) => setIsVisible(entries[0].isIntersecting), options);
        if (containerRef.current) {
            observer.observe(containerRef.current);
        }
        const reactNode = containerRef.current;
        return () => (reactNode ? observer.unobserve(reactNode) : undefined);
    }, [containerRef, options]);
    return [containerRef, isVisible];
};
//# sourceMappingURL=useElementOnScreen.js.map